var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineReceiptSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.94 21.64-1.01-1.35c-.21-.28-.49-.44-.79-.46-.3-.02-.6.12-.84.37-1.45 1.55-2.55 1.42-3.08 1.22-.54-.21-1.45-.9-1.45-3.12V7.04c0-4.44 1.28-5.79 5.47-5.79h7.55c4.19 0 5.47 1.35 5.47 5.79v4.26c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7.04c0-3.61-.63-4.29-3.97-4.29H8.24c-3.34 0-3.97.68-3.97 4.29V18.3c0 1.05.26 1.63.5 1.72.18.07.67-.03 1.43-.84.55-.58 1.27-.89 2.02-.85.74.04 1.44.43 1.91 1.06l1.02 1.35a.75.75 0 0 1-.61 1.2c-.23 0-.45-.1-.6-.3z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.2c0-2.18 1.77-3.95 3.95-3.95s3.95 1.77 3.95 3.95-1.77 3.95-3.95 3.95-3.95-1.77-3.95-3.95zm1.5 0c0 1.35 1.1 2.45 2.45 2.45s2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45-2.45 1.1-2.45 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.47 22.53-1-1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM8 7.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8zM9 11.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineReceiptSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-receipt-search.b62f4e29e0d1aa044fe64c61766f3ab4.svg";
export { ForwardRef as ReactComponent };